var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1662(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 20,
    viewBox: "0 0 20.002 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(487.95 -126.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M-425.193,410.622c-1.66,0-3.32,0-4.98,0a3,3,0,0,1-1.813-.559,2.523,2.523,0,0,1-1.054-2,10.783,10.783,0,0,1,.541-4.092,4.234,4.234,0,0,1,1.273-1.952,3.053,3.053,0,0,1,1.951-.673.9.9,0,0,1,.429.158c.312.187.6.406.918.591a5.058,5.058,0,0,0,5.4.039,4.263,4.263,0,0,0,.7-.462,1.488,1.488,0,0,1,1.43-.245,3.291,3.291,0,0,1,2.239,1.924,7.373,7.373,0,0,1,.687,2.443,18.3,18.3,0,0,1,.121,2.062,2.635,2.635,0,0,1-2.472,2.735,5.232,5.232,0,0,1-.564.033Q-422.791,410.625-425.193,410.622Z",
    transform: "translate(-52.752 -263.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-337.5,208.559a4.276,4.276,0,0,1-4.3-4.279,4.283,4.283,0,0,1,4.282-4.3,4.28,4.28,0,0,1,4.3,4.28A4.278,4.278,0,0,1-337.5,208.559Z",
    transform: "translate(-140.446 -70.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M-464.076,129.8a2.838,2.838,0,0,1-2.839,2.856,2.844,2.844,0,0,1-2.88-2.837,2.857,2.857,0,0,1,2.812-2.87A2.845,2.845,0,0,1-464.076,129.8Z",
    transform: "translate(-17.445 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M-137.72,132.65a2.838,2.838,0,0,1-2.856-2.859,2.845,2.845,0,0,1,2.871-2.848,2.854,2.854,0,0,1,2.848,2.854A2.846,2.846,0,0,1-137.72,132.65Z",
    transform: "translate(-333.804 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M-126.091,274.353c.4.065.791.143,1.182.187a4.341,4.341,0,0,0,2.294-.492c.242-.11.474-.241.711-.361a.687.687,0,0,1,.819.2.3.3,0,0,1,.037.163c0,1.581,0,3.162,0,4.744a.211.211,0,0,1-.127.211,2.835,2.835,0,0,1-1.39.319c-.429.007-.859,0-1.288,0a.3.3,0,0,1-.2-.079,3.914,3.914,0,0,0-2.891-1.354A4.969,4.969,0,0,0-126.091,274.353Z",
    transform: "translate(-346.905 -140.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M-482.052,277.863a3.9,3.9,0,0,0-2.415.9,2.267,2.267,0,0,0-.351.337.537.537,0,0,1-.506.209c-.507-.021-1.015-.013-1.521-.033a2.084,2.084,0,0,1-.994-.307.247.247,0,0,1-.106-.176q-.009-2.391,0-4.783a.313.313,0,0,1,.09-.2.658.658,0,0,1,.832-.113,6.827,6.827,0,0,0,2.005.776,4.189,4.189,0,0,0,1.926-.132l.192-.055A4.975,4.975,0,0,0-482.052,277.863Z",
    transform: "translate(0 -140.925)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1662);
export default __webpack_public_path__ + "static/media/Group 1662.aca3d8d4ad64e7c1fac763c5b8a2949a.svg";
export { ForwardRef as ReactComponent };